import { render, staticRenderFns } from "./ConfirmeBoletoView.vue?vue&type=template&id=1a480a75&scoped=true&"
import script from "./ConfirmeBoletoView.vue?vue&type=script&lang=js&"
export * from "./ConfirmeBoletoView.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmeBoletoView.vue?vue&type=style&index=0&id=1a480a75&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a480a75",
  null
  
)

export default component.exports